// @flow

import React from 'react';

import { StyledPopup } from '../../../common-utils/styledComponents';

import { UploadButton } from './UploadButton';

export const ImportBaselineButton = ({ disabled, onClick, floated = 'right', size = 'mini' }) => (
  <StyledPopup
    content={
      disabled
        ? 'First delete all existing Clusters, Flink Pools, and Stream Governance configs!'
        : 'Import Baseline'
    }
    flowing={true}
    hoverable={true}
    offset={[0, 0]}
    on={['hover']}
    positionFixed={true}
    trigger={
      <span style={{ float: floated }}>
        <UploadButton disabled={disabled} floated={null} onClick={onClick} size={size} />
      </span>
    }
  />
);
